module.exports = __webpack_public_path__ + "static/media/5.129e4888.png";